import ListIcon from '@material-ui/icons/List';

import List from './List';

export default {
  list: List,
  icon: ListIcon,
};
